import * as API from "./base";

const exports = API.crudify("professional", "/api/professionals");
export const create = exports.create;
export const destroy = exports.destroy;
export const index = exports.index;
export const show = exports.show;
export const update = exports.update;
